import React, { useEffect, useContext } from 'react';
import AppContext from '../context'
import { jdMobileURL } from '../utils'

interface Props {
    
}

const JDFrame: React.FC<Props> = () => {
    
    const { updateCart, state } = useContext(AppContext)

    useEffect(() => {
        window.addEventListener('message', (msg) => {
            if (msg.data.type === 'smartagent-cart-update' && state === "buying") {
                updateCart(msg.data.cartID);
            }
        })

        return () => window.removeEventListener('message', () => {})

    }, [updateCart, state])

    return (
        <div className="iframe-wrapper">
            <iframe title="jd mobile" src={jdMobileURL} seamless sandbox="allow-forms allow-same-origin allow-scripts allow-modals allow-popups allow-popups-to-escape-sandbox" />
        </div>
    )
}

export default JDFrame
